<template>
  <v-card>
    <v-card-title>
      <div class="headline">Scheme</div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6 v-if="!newScheme">
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{schemeForm.scheme}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field :label="labels.scheme" v-model="schemeForm.scheme" :error-messages="errors.collect('scheme')" v-validate="'required|param|max:4'" data-vv-name="scheme" :data-vv-as="labels.scheme"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.schemeDesc" v-model="schemeForm.schemeDesc" :error-messages="errors.collect('schemeDesc')" v-validate="'required|entry|max:128'" data-vv-name="schemeDesc" :data-vv-as="labels.schemeDesc"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :label="labels.schemeType" v-model="schemeForm.schemeType" :items="schemeTypeList()" item-text="label" item-value="value" data-vv-name="schemeType" :data-vv-as="labels.schemeType" :error-messages="errors.collect('schemeType')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <!-- space -->
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.minInsdAge" v-model="schemeForm.minInsdAge" :error-messages="errors.collect('minInsdAge')" v-validate="'numeric|max:10'" data-vv-name="minInsdAge" :data-vv-as="labels.schemeDesc"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.maxInsdAge" v-model="schemeForm.maxInsdAge" :error-messages="errors.collect('maxInsdAge')" v-validate="'numeric|max:10'" data-vv-name="maxInsdAge" :data-vv-as="labels.maxInsdAge"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.maxInsdRenAge" v-model="schemeForm.maxInsdRenAge" :error-messages="errors.collect('maxInsdRenAge')" v-validate="'numeric|max:10'" data-vv-name="maxInsdRenAge" :data-vv-as="labels.maxInsdRenAge"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.maxChildAge" v-model="schemeForm.maxChildAge" :error-messages="errors.collect('maxChildAge')" v-validate="'numeric|max:10'" data-vv-name="maxChildAge" :data-vv-as="labels.maxChildAge"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.maxStudentAge" v-model="schemeForm.maxStudentAge" :error-messages="errors.collect('maxStudentAge')" v-validate="'numeric|max:10'" data-vv-name="maxStudentAge" :data-vv-as="labels.maxStudentAge"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
        {{ newScheme ? 'Save Scheme' : 'Update Scheme' }}
        <v-icon right>{{newScheme ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { schemeType } from '@/const/params'
export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        schemeDesc: 'Scheme Description',
        schemeType: 'Scheme Type',
        minInsdAge: 'Minimum Insured Age',
        maxInsdAge: 'Maximum Insured Age',
        maxInsdRenAge: 'Maximum Insured Renewal Age',
        maxChildAge: 'Maximum Child Age',
        maxStudentAge: 'Maximum Student Age'
      },
      schemeForm: {
        scheme: null,
        schemeDesc: null,
        schemeType: null,
        minInsdAge: null,
        maxInsdAge: null,
        maxInsdRenAge: null,
        maxChildAge: null,
        maxStudentAge: null
      },
      submitting: false,
      newScheme: false
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.schemeMenu.menu.schemeGet
      if (apiURI) {
        try {
          const expand = {
            scheme: this.scheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.schemeForm.scheme = data.scheme.scheme
            this.schemeForm.schemeDesc = data.scheme.schemeDesc
            this.schemeForm.schemeType = data.scheme.schemeType
            this.schemeForm.minInsdAge = data.scheme.minInsdAge
            this.schemeForm.maxInsdAge = data.scheme.maxInsdAge
            this.schemeForm.maxInsdRenAge = data.scheme.maxInsdRenAge
            this.schemeForm.maxChildAge = data.scheme.maxChildAge
            this.schemeForm.maxStudentAge = data.scheme.maxStudentAge
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Scheme Review')
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newScheme) {
            this.doCreateGeneral()
          } else {
            this.doUpdateGeneral()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateGeneral() {
      try {
        const apiURI = this.schemeMenu.menu.schemeCreate
        if (apiURI) {
          const formatForm = {
            scheme: this.schemeForm.scheme,
            schemeDesc: this.schemeForm.schemeDesc,
            schemeType: this.schemeForm.schemeType,
            minInsdAge: this.schemeForm.minInsdAge,
            maxInsdAge: this.schemeForm.maxInsdAge,
            maxInsdRenAge: this.schemeForm.maxInsdRenAge,
            maxChildAge: this.schemeForm.maxChildAge,
            maxStudentAge: this.schemeForm.maxStudentAge
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'schemesList' })
          }
        }
      } catch (error) {
        const { data } = error
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUpdateGeneral() {
      try {
        const apiURI = this.menu.schemeUpdate
        if (apiURI) {
          const formatForm = {
            scheme: this.schemeForm.scheme,
            schemeDesc: this.schemeForm.schemeDesc,
            schemeType: this.schemeForm.schemeType,
            minInsdAge: this.schemeForm.minInsdAge,
            maxInsdAge: this.schemeForm.maxInsdAge,
            maxInsdRenAge: this.schemeForm.maxInsdRenAge,
            maxChildAge: this.schemeForm.maxChildAge,
            maxStudentAge: this.schemeForm.maxStudentAge
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
          }
        }
      } catch (error) {
        const { data } = error
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.schemeForm.scheme = null
      this.schemeForm.schemeDesc = null
      this.schemeForm.schemeType = null
      this.schemeForm.minInsdAge = null
      this.schemeForm.maxInsdAge = null
      this.schemeForm.maxInsdRenAge = null
      this.schemeForm.maxChildAge = null
      this.schemeForm.maxStudentAge = null
    },
    schemeTypeList() {
      const list = Object.freeze(schemeType)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    }
  },
  mounted() {
    if (this.scheme === 'new') {
      this.newScheme = true
      this.doClearForm()
    } else {
      this.doInit()
      this.newScheme = false
    }
  },
  created() {
  },
  mixins: [
    MessageMixin
  ],
  props: {
    scheme: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
</style>
